import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0006',
    ecrans: ['00-2']
});
